import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { VolumetryComponent } from './volumetry.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.VOLUMETRY' };
var routes = [
    {
        path: 'relatorios/volumetria',
        component: VolumetryComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var VolumetryModule = /** @class */ (function () {
    function VolumetryModule() {
    }
    return VolumetryModule;
}());
export { VolumetryModule };
export { ɵ0 };
